import { template as template_edd34a80db9f44c99d131087d4b701ae } from "@ember/template-compiler";
import { t } from 'ember-intl';
import { TaskToVariablesConfig } from 'eflex/components/task-variables-config';
export default template_edd34a80db9f44c99d131087d4b701ae(`
<div class="row form-row model-specific gx-2 mb-4">
  <div class="col">
    <@form.element
      class="program-name is-required"
      @label={{t "program"}}
      @property="programName"
      @size="sm"
    />
  </div>
  <div class="col">
    <@form.element
      class="light-guide-watch-variable is-required"
      @label={{t "watchVariable"}}
      @property="lightGuideWatchVariable"
      @size="sm"
    />
  </div>
  <div class="col">
    <@form.element
      class="light-guide-watch-variable-expected is-required"
      @label={{t "watchVariableExpected"}}
      @property="lightGuideWatchVariableExpected"
      @size="sm"
    />
  </div>
</div>

<TaskToVariablesConfig
  @form={{@form}}
  @disabled={{@disabled}}
  @task={{@task}}
  @taskConfig={{@taskConfig}}
/>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
